import { httpClient } from "@utils";
import { FailedLoginDataDto } from "@api-types/user/FailedLoginDataDto";
import { ContextOptions, ApiRequestContextData } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { FailedLoginsReportFilter } from "@data-types";

export default class UserLoginHistoriesApiService {
	static baseUrl(context: ApiRequestContextData) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/user-login-histories`;
	}
	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getUserFailedLogins(
		filterObject: FailedLoginsReportFilter,
		options?: ContextOptions
	): Promise<FailedLoginDataDto> {
		const context = getApiRequestContext(options);

		const filter = new URLSearchParams();

		filter.append("reportMode", JSON.stringify(filterObject.reportMode));
		filter.append("rpp", JSON.stringify(filterObject.rpp));

		if (filterObject.hourInterval) {
			filter.append(
				"hourInterval",
				JSON.stringify(filterObject.hourInterval)
			);
		}

		return httpClient.get(
			`${this.baseUrl(context)}/failed-logins/${context?.userId}?${filter.toString()}`,
			this.getRequestHeaders(context)
		);
	}
}
